import React from "react";
import CustomSelect from "../common/Select";
import { escolaridades } from "../../../resources/Helper";

function SelectorEscolaridad({ value, onChange, error, required = false }) {
  // Convertir escolaridades a formato de opciones
  const opcionesEscolaridad = escolaridades.map(item => ({
    value: item.id,
    label: item.nombre
  }));

  return (
    <CustomSelect
      options={opcionesEscolaridad}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Escolaridad"
      error={error}
      required={required}
    />
  );
}

export default SelectorEscolaridad;